import React, { useState } from 'react';
import {
    MenuItem,
    Chip,
    Menu,
} from '@mui/material';
import { trakrefFontFamilySemiBold } from '../../../utils';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

// testing scrollable select menu
const MenuProps = {
    // overflowY: 'scroll',
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
};

const chipStyle = {
    '&.MuiChip-root': { borderRadius: 0, backgroundColor: '#fff', border: '1px solid #E3E8EB' },
    '&.MuiChip-label': { fontFamily: trakrefFontFamilySemiBold }
};

const ChipSelect = ({
    id,
    disabled,
    item,
    label,
    options,
    onChange,
    deletable,
}) => {
    const noItemSelected = { id: "", label: "" };
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (selectedItem) => {
        onChange(selectedItem);
        setAnchorEl(null);
    };

    return (
        <>
            <Chip
                label={item.label ? `${label}: ${item.label}` : label}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                onDelete={(e) => deletable && item.label ? onChange(noItemSelected) : setAnchorEl(e.currentTarget)}
                deleteIcon={deletable && item.label ? <CloseIcon /> : <KeyboardArrowDownIcon />}
                variant="outlined"
                disabled={disabled}
                id={id}
                sx={{...chipStyle}}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                PaperProps={{  
                    style: {  
                        width: 300,
                        height: 'auto',
                        maxHeight: 300,
                    }
                }}
            >
                {options.map((item) => (
                    <MenuItem
                        key={item.label}
                        onClick={() => handleClick(item)}
                    >
                        {item.label ? item.label : item.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

ChipSelect.propTypes = {
    item: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    showNullOption: PropTypes.bool,
    id: PropTypes.string,
    deletable: PropTypes.bool,
};

ChipSelect.defaultProps = {
    required: false,
    disabled: false,
    showNullOption: false,
    id: "",
    deletable: false,
};

export default ChipSelect;